import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "../firebaseConfig.js";
import vacancyPositions from "../data/vacancyPosition.js";

/**
 * Fetches available vacancy positions from Firestore.
 * @returns {Promise<string[]>} Array of position names
 */
export async function fetchVacancyPositions() {
  const snapshot = await getDocs(collection(db, "vacancyPositions"));
  return snapshot.docs.map((doc) => doc.data().name);
}

/**
 * Validates the job application form fields.
 * @param {Object} form - Form data
 * @returns {string|null} Error message or null if valid
 */
export function validateJobApplicationForm(form) {
  if (
    !form.firstName ||
    !form.lastName ||
    !form.email ||
    !form.phone ||
    !form.position ||
    !form.startDate ||
    !form.employment ||
    !form.address ||
    !form.verified
  ) {
    return "Please fill out all required fields and verify you are not a robot.";
  }
  // Simple email format check
  if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(form.email)) {
    return "Please enter a valid email address.";
  }
  // Simple Bhutan phone check
  if (!/^(17|77)\d{6}$/.test(form.phone)) {
    return "Please enter a valid Bhutan mobile number (17XXXXXX or 77XXXXXX).";
  }
  return null;
}

/**
 * Uploads local vacancyPositions array to Firestore.
 * Only adds positions that do not already exists.
 */
export async function uploadVacancyPositionsToFirestore() {
  const colRef = collection(db, "vacancyPositions");
  const snapshot = await getDocs(colRef);
  const existingNames = snapshot.docs.map((doc) => doc.data().name);

  for (const pos of vacancyPositions) {
    if (!existingNames.includes(pos.name)) {
      await addDoc(colRef, pos);
      console.log(`Added: ${pos.name}`);
    } else {
      console.log(`Already exists: ${pos.name}`);
    }
  }
}
